import { render, staticRenderFns } from "./doctorDetailV2.vue?vue&type=template&id=41a6fafe&scoped=true&"
import script from "./doctorDetailV2.vue?vue&type=script&lang=js&"
export * from "./doctorDetailV2.vue?vue&type=script&lang=js&"
import style0 from "./doctorDetailV2.vue?vue&type=style&index=0&id=41a6fafe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a6fafe",
  null
  
)

export default component.exports